import { AiNodeContext } from "@intelligems/ig-types";
import { createAction, createReducer } from "@reduxjs/toolkit";
import type { RootState } from "@src/store/rootState";
export interface InitialContextEntry {
  context: AiNodeContext;
  isValid: boolean;
  error?: string;
  rawText?: string;
}

export interface WorkflowInitialContextState {
  contexts: Record<string, InitialContextEntry>;
}

const initialState: WorkflowInitialContextState = {
  contexts: {},
};

export const setInitialContext = createAction<{
  workflowId: string;
  context: AiNodeContext;
  isValid: boolean;
  error?: string;
  rawText?: string;
}>("workflowInitialContext/setInitialContext");
export const setInitialContextRawText = createAction<{
  workflowId: string;
  rawText: string;
}>("workflowInitialContext/setInitialContextRawText");
export const clearInitialContext = createAction<string>(
  "workflowInitialContext/clearInitialContext"
);

export const workflowInitialContextReducer = createReducer(
  initialState,
  (builder) => {
    builder
      .addCase(setInitialContext, (state, action) => {
        const { workflowId, context, isValid, error, rawText } = action.payload;
        (state as WorkflowInitialContextState).contexts[workflowId] = {
          context,
          isValid,
          error,
          rawText,
        };
      })
      .addCase(setInitialContextRawText, (state, action) => {
        const { workflowId, rawText } = action.payload;
        const contexts = (state as WorkflowInitialContextState).contexts;
        const existing = contexts[workflowId];
        if (existing) {
          existing.rawText = rawText;
        } else {
          contexts[workflowId] = {
            context: {} as AiNodeContext,
            isValid: true,
            rawText,
          };
        }
      })
      .addCase(clearInitialContext, (state, action) => {
        delete state.contexts[action.payload];
      });
  }
);

export const getInitialContext = (
  state: { workflowInitialContext: WorkflowInitialContextState },
  workflowId: string
) =>
  state.workflowInitialContext.contexts[workflowId] || {
    context: "",
    isValid: true,
  };
export const getAllInitialContexts = (state: {
  workflowInitialContext: WorkflowInitialContextState;
}) => state.workflowInitialContext.contexts;

export const makeGetInitialContext =
  (workflowId: string) => (state: RootState) => {
    return (
      state.workflowInitialContext.contexts[workflowId] || {
        context: "",
        isValid: true,
      }
    );
  };

export const getInitialContextByWorkflowId =
  (workflowId: string) => (state: RootState) => {
    return getInitialContext(
      { workflowInitialContext: state.workflowInitialContext },
      workflowId
    );
  };
